import { combineReducers } from "redux";

import config from "./config";
import ui from "./ui";

// Domain Reducer
export default combineReducers({
  config,
  ui
});
